import { lazy } from 'react';

const Offers = lazy(() => import('./OffersPage'));

const OffersConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'processor/offers',
      element: <Offers />,
      children: [
        {
          path: ':id',
          element: <Offers />,
        },
      ],
    },
  ],
};

export default OffersConfig;
